import { useLocaleStore } from '~/stores/useLocaleStore';
import { usePartnerConfig } from '~/stores/usePartnerConfig';
import { useCustomTariffStore } from "~/stores/useCustomTariffStore";
import { usePartnersStore } from '~/stores/usePartnersStore';

export default defineNuxtPlugin(async (nuxtApp) => {
  const { getAllLanguages, languages } = useLocaleStore();
  const { getPartnerConfig, config } = usePartnerConfig();
  const { getUnlimTariffs, getPromiseTariffs } = useCustomTariffStore();
  const { getPartners } = usePartnersStore();

  await getPartnerConfig();

  const promises = [
    getAllLanguages(),
    getUnlimTariffs(),
    getPromiseTariffs(),
  ];

  await Promise.all(promises);
});
